import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "xwide7": "user-bag-page-by-city-91bba550-xwide7-WXUgJq",
  "confinedOffset11": "user-bag-page-by-city-91bba550-confinedOffset11-WXUgJq",
  "wideOffset4": "user-bag-page-by-city-91bba550-wideOffset4-WXUgJq",
  "xwide1": "user-bag-page-by-city-91bba550-xwide1-WXUgJq",
  "wideOffset6": "user-bag-page-by-city-91bba550-wideOffset6-WXUgJq",
  "wide6": "user-bag-page-by-city-91bba550-wide6-WXUgJq",
  "xwide2": "user-bag-page-by-city-91bba550-xwide2-WXUgJq",
  "wideOffset0": "user-bag-page-by-city-91bba550-wideOffset0-WXUgJq",
  "tiny3": "user-bag-page-by-city-91bba550-tiny3-WXUgJq",
  "default8": "user-bag-page-by-city-91bba550-default8-WXUgJq",
  "default11": "user-bag-page-by-city-91bba550-default11-WXUgJq",
  "tinyOffset4": "user-bag-page-by-city-91bba550-tinyOffset4-WXUgJq",
  "confinedOffset10": "user-bag-page-by-city-91bba550-confinedOffset10-WXUgJq",
  "wide8": "user-bag-page-by-city-91bba550-wide8-WXUgJq",
  "defaultOffset2": "user-bag-page-by-city-91bba550-defaultOffset2-WXUgJq",
  "default5": "user-bag-page-by-city-91bba550-default5-WXUgJq",
  "tiny1": "user-bag-page-by-city-91bba550-tiny1-WXUgJq",
  "wideOffset11": "user-bag-page-by-city-91bba550-wideOffset11-WXUgJq",
  "defaultOffset1": "user-bag-page-by-city-91bba550-defaultOffset1-WXUgJq",
  "defaultOffset9": "user-bag-page-by-city-91bba550-defaultOffset9-WXUgJq",
  "confined11": "user-bag-page-by-city-91bba550-confined11-WXUgJq",
  "wide3": "user-bag-page-by-city-91bba550-wide3-WXUgJq",
  "wide10": "user-bag-page-by-city-91bba550-wide10-WXUgJq",
  "wideOffset8": "user-bag-page-by-city-91bba550-wideOffset8-WXUgJq",
  "wideOffset2": "user-bag-page-by-city-91bba550-wideOffset2-WXUgJq",
  "xwideOffset4": "user-bag-page-by-city-91bba550-xwideOffset4-WXUgJq",
  "row": "user-bag-page-by-city-91bba550-row-WXUgJq",
  "tiny5": "user-bag-page-by-city-91bba550-tiny5-WXUgJq",
  "xwideOffset6": "user-bag-page-by-city-91bba550-xwideOffset6-WXUgJq",
  "tinyOffset3": "user-bag-page-by-city-91bba550-tinyOffset3-WXUgJq",
  "wide12": "user-bag-page-by-city-91bba550-wide12-WXUgJq",
  "confinedOffset6": "user-bag-page-by-city-91bba550-confinedOffset6-WXUgJq",
  "confined10": "user-bag-page-by-city-91bba550-confined10-WXUgJq",
  "confinedOffset7": "user-bag-page-by-city-91bba550-confinedOffset7-WXUgJq",
  "xwide12": "user-bag-page-by-city-91bba550-xwide12-WXUgJq",
  "xwideOffset3": "user-bag-page-by-city-91bba550-xwideOffset3-WXUgJq",
  "wide9": "user-bag-page-by-city-91bba550-wide9-WXUgJq",
  "tinyOffset0": "user-bag-page-by-city-91bba550-tinyOffset0-WXUgJq",
  "default7": "user-bag-page-by-city-91bba550-default7-WXUgJq",
  "default2": "user-bag-page-by-city-91bba550-default2-WXUgJq",
  "default1": "user-bag-page-by-city-91bba550-default1-WXUgJq",
  "defaultOffset4": "user-bag-page-by-city-91bba550-defaultOffset4-WXUgJq",
  "confined5": "user-bag-page-by-city-91bba550-confined5-WXUgJq",
  "xwide8": "user-bag-page-by-city-91bba550-xwide8-WXUgJq",
  "xwide5": "user-bag-page-by-city-91bba550-xwide5-WXUgJq",
  "wide1": "user-bag-page-by-city-91bba550-wide1-WXUgJq",
  "xwide3": "user-bag-page-by-city-91bba550-xwide3-WXUgJq",
  "tinyOffset1": "user-bag-page-by-city-91bba550-tinyOffset1-WXUgJq",
  "confinedOffset0": "user-bag-page-by-city-91bba550-confinedOffset0-WXUgJq",
  "grid": "user-bag-page-by-city-91bba550-grid-WXUgJq",
  "xwideOffset2": "user-bag-page-by-city-91bba550-xwideOffset2-WXUgJq",
  "confinedOffset2": "user-bag-page-by-city-91bba550-confinedOffset2-WXUgJq",
  "confined12": "user-bag-page-by-city-91bba550-confined12-WXUgJq",
  "wide11": "user-bag-page-by-city-91bba550-wide11-WXUgJq",
  "default0": "user-bag-page-by-city-91bba550-default0-WXUgJq",
  "defaultOffset5": "user-bag-page-by-city-91bba550-defaultOffset5-WXUgJq",
  "confined2": "user-bag-page-by-city-91bba550-confined2-WXUgJq",
  "wideGridContainer": "user-bag-page-by-city-91bba550-wideGridContainer-WXUgJq",
  "tiny0": "user-bag-page-by-city-91bba550-tiny0-WXUgJq",
  "confined4": "user-bag-page-by-city-91bba550-confined4-WXUgJq",
  "confined9": "user-bag-page-by-city-91bba550-confined9-WXUgJq",
  "tiny9": "user-bag-page-by-city-91bba550-tiny9-WXUgJq",
  "confinedOffset4": "user-bag-page-by-city-91bba550-confinedOffset4-WXUgJq",
  "confined3": "user-bag-page-by-city-91bba550-confined3-WXUgJq",
  "xwideOffset11": "user-bag-page-by-city-91bba550-xwideOffset11-WXUgJq",
  "tiny11": "user-bag-page-by-city-91bba550-tiny11-WXUgJq",
  "defaultOffset10": "user-bag-page-by-city-91bba550-defaultOffset10-WXUgJq",
  "xwide6": "user-bag-page-by-city-91bba550-xwide6-WXUgJq",
  "tiny10": "user-bag-page-by-city-91bba550-tiny10-WXUgJq",
  "armstrongGridContainer": "user-bag-page-by-city-91bba550-armstrongGridContainer-WXUgJq",
  "tiny8": "user-bag-page-by-city-91bba550-tiny8-WXUgJq",
  "wideOffset5": "user-bag-page-by-city-91bba550-wideOffset5-WXUgJq",
  "default9": "user-bag-page-by-city-91bba550-default9-WXUgJq",
  "tinyOffset7": "user-bag-page-by-city-91bba550-tinyOffset7-WXUgJq",
  "tinyOffset10": "user-bag-page-by-city-91bba550-tinyOffset10-WXUgJq",
  "tiny12": "user-bag-page-by-city-91bba550-tiny12-WXUgJq",
  "confined0": "user-bag-page-by-city-91bba550-confined0-WXUgJq",
  "confinedOffset8": "user-bag-page-by-city-91bba550-confinedOffset8-WXUgJq",
  "tiny6": "user-bag-page-by-city-91bba550-tiny6-WXUgJq",
  "wideOffset9": "user-bag-page-by-city-91bba550-wideOffset9-WXUgJq",
  "tiny7": "user-bag-page-by-city-91bba550-tiny7-WXUgJq",
  "wideOffset10": "user-bag-page-by-city-91bba550-wideOffset10-WXUgJq",
  "xwide10": "user-bag-page-by-city-91bba550-xwide10-WXUgJq",
  "wide4": "user-bag-page-by-city-91bba550-wide4-WXUgJq",
  "wideOffset7": "user-bag-page-by-city-91bba550-wideOffset7-WXUgJq",
  "gridContainer": "user-bag-page-by-city-91bba550-gridContainer-WXUgJq",
  "xwideOffset8": "user-bag-page-by-city-91bba550-xwideOffset8-WXUgJq",
  "standardGridContainer": "user-bag-page-by-city-91bba550-standardGridContainer-WXUgJq",
  "default6": "user-bag-page-by-city-91bba550-default6-WXUgJq",
  "default12": "user-bag-page-by-city-91bba550-default12-WXUgJq",
  "tinyOffset9": "user-bag-page-by-city-91bba550-tinyOffset9-WXUgJq",
  "xwideOffset5": "user-bag-page-by-city-91bba550-xwideOffset5-WXUgJq",
  "confinedOffset1": "user-bag-page-by-city-91bba550-confinedOffset1-WXUgJq",
  "xwideOffset0": "user-bag-page-by-city-91bba550-xwideOffset0-WXUgJq",
  "wideOffset1": "user-bag-page-by-city-91bba550-wideOffset1-WXUgJq",
  "xwide9": "user-bag-page-by-city-91bba550-xwide9-WXUgJq",
  "defaultOffset8": "user-bag-page-by-city-91bba550-defaultOffset8-WXUgJq",
  "defaultOffset11": "user-bag-page-by-city-91bba550-defaultOffset11-WXUgJq",
  "default3": "user-bag-page-by-city-91bba550-default3-WXUgJq",
  "default10": "user-bag-page-by-city-91bba550-default10-WXUgJq",
  "xwideOffset10": "user-bag-page-by-city-91bba550-xwideOffset10-WXUgJq",
  "wide5": "user-bag-page-by-city-91bba550-wide5-WXUgJq",
  "confinedOffset5": "user-bag-page-by-city-91bba550-confinedOffset5-WXUgJq",
  "tinyOffset5": "user-bag-page-by-city-91bba550-tinyOffset5-WXUgJq",
  "confinedOffset3": "user-bag-page-by-city-91bba550-confinedOffset3-WXUgJq",
  "defaultOffset6": "user-bag-page-by-city-91bba550-defaultOffset6-WXUgJq",
  "wide0": "user-bag-page-by-city-91bba550-wide0-WXUgJq",
  "col": "user-bag-page-by-city-91bba550-col-WXUgJq",
  "confined7": "user-bag-page-by-city-91bba550-confined7-WXUgJq",
  "xwide11": "user-bag-page-by-city-91bba550-xwide11-WXUgJq",
  "wideOffset3": "user-bag-page-by-city-91bba550-wideOffset3-WXUgJq",
  "xwideOffset1": "user-bag-page-by-city-91bba550-xwideOffset1-WXUgJq",
  "xwideOffset7": "user-bag-page-by-city-91bba550-xwideOffset7-WXUgJq",
  "wide2": "user-bag-page-by-city-91bba550-wide2-WXUgJq",
  "confined1": "user-bag-page-by-city-91bba550-confined1-WXUgJq",
  "tinyOffset8": "user-bag-page-by-city-91bba550-tinyOffset8-WXUgJq",
  "xwide4": "user-bag-page-by-city-91bba550-xwide4-WXUgJq",
  "confinedOffset9": "user-bag-page-by-city-91bba550-confinedOffset9-WXUgJq",
  "tiny4": "user-bag-page-by-city-91bba550-tiny4-WXUgJq",
  "wide7": "user-bag-page-by-city-91bba550-wide7-WXUgJq",
  "xwide0": "user-bag-page-by-city-91bba550-xwide0-WXUgJq",
  "tinyOffset11": "user-bag-page-by-city-91bba550-tinyOffset11-WXUgJq",
  "tiny2": "user-bag-page-by-city-91bba550-tiny2-WXUgJq",
  "confined8": "user-bag-page-by-city-91bba550-confined8-WXUgJq",
  "tinyOffset6": "user-bag-page-by-city-91bba550-tinyOffset6-WXUgJq",
  "tinyOffset2": "user-bag-page-by-city-91bba550-tinyOffset2-WXUgJq",
  "default4": "user-bag-page-by-city-91bba550-default4-WXUgJq",
  "xwideOffset9": "user-bag-page-by-city-91bba550-xwideOffset9-WXUgJq",
  "defaultOffset7": "user-bag-page-by-city-91bba550-defaultOffset7-WXUgJq",
  "confined6": "user-bag-page-by-city-91bba550-confined6-WXUgJq",
  "defaultOffset3": "user-bag-page-by-city-91bba550-defaultOffset3-WXUgJq"
};